module.exports = __webpack_public_path__ + "static/media/Step3.c87cf884.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/tutorial/Step3.jpg
// module id = 2237
// module chunks = 0